
const COUPON_UNAUDIT_LIST = 'COUPON_UNAUDIT_LIST';
const COUPON_UNAUDIT_PAGE = 'COUPON_UNAUDIT_PAGE';
const COUPON_UNAUDIT_CONDITION = 'COUPON_UNAUDIT_CONDITION';
const COUPON_UNAUDIT_ADD_CONDITION = 'COUPON_UNAUDIT_ADD_CONDITION';

const CouponUnauditModel = function () {
  const name = 'Couponunaudit';
  return {
    name,
    state: {
      list: [],
      condition: {
        applyUserId: '',
        status: '0',
        userId: '',
        reviewer: '',
        startDt: '',
        endDt:'',
        index:0,
      },
      addCondition:{
        title:'',
        subtitle:'',
        remark:'',
        startTs:'',
        endTs:'',
        count:'',
        couponFee:'',
        minPay:'',
        type:'',
        source:'',
        iconUrl:'',
        newUser:'',
        userId:[],

      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
        getAddCondition: () => currentState.addCondition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: COUPON_UNAUDIT_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: COUPON_UNAUDIT_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: COUPON_UNAUDIT_CONDITION,
          key,
          value
        });
      },
      changeAddCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: COUPON_UNAUDIT_ADD_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = CouponUnauditModel.state.list, action) => {
        if (action.type === COUPON_UNAUDIT_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = CouponUnauditModel.state.page, action) => {
        if (action.type === COUPON_UNAUDIT_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = CouponUnauditModel.state.condition, action) => {
        if (action.type === COUPON_UNAUDIT_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
      addCondition: (state = CouponUnauditModel.state.addCondition, action) => {
        if (action.type === COUPON_UNAUDIT_ADD_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      }
    }
  };
}();

export default CouponUnauditModel;


// WEBPACK FOOTER //
// ./src/models/CouponUnauditModel.js